import { TestOrganization } from './types';

export const artemisTestingOrganization: TestOrganization = {
  highbondId: '2512',
  name: 'Artemis Testing',
  urlPrefix: 'artemis-testing1',
  id: 'a1b2c3d4-5678-4abc-9def-artemis2512aa',
  subdomain: 'artemis-testing1',
};

export const devInternalControlsTestOrganizations: TestOrganization[] = [
  artemisTestingOrganization,
];
